var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCheckInCircleEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_check-in-circle",
    transform: "translate(-2.000000, -2.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 26,
    height: 26
  }), /*#__PURE__*/React.createElement("g", {
    id: "Check-+-circle",
    transform: "translate(2.000000, 2.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9710526,21.9421053 C4.91190757,21.9421053 -1.34688235e-14,17.0301977 -1.42108547e-14,10.9710526 C-1.4952886e-14,4.91190757 4.91190757,-1.30978078e-14 10.9710526,-1.42108547e-14 C17.0301977,-1.53239016e-14 21.9421053,4.91190757 21.9421053,10.9710526 C21.9346621,17.027112 17.027112,21.9346621 10.9710526,21.9421053 Z M10.9710526,1.35087719 C5.65797645,1.35087719 1.35087719,5.65797645 1.35087719,10.9710526 C1.35087719,16.2841288 5.65797645,20.5912281 10.9710526,20.5912281 C16.2841288,20.5912281 20.5912281,16.2841288 20.5912281,10.9710526 C20.5848479,5.66062145 16.2814838,1.35725737 10.9710526,1.35087719 Z",
    id: "Shape"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckInCircleEmpty);
export default __webpack_public_path__ + "static/media/icon_check-in-circle-empty.a472718ef9149ee273f3b3c7e6b19fad.svg";
export { ForwardRef as ReactComponent };